enum DynamicGeofencesEvent {
  POLYGON_CHANGED = 'onPolygonsChanged',
  POLYGON_LOADING = 'onPolygonsLoading',
  POLYGON_CLICKED = 'onPolygonClicked',
  GEOFENCE_UPDATED = 'onDynamicGeofenceUpdated',
}

export default DynamicGeofencesEvent;
